<template>
  <b-container>
    <Nav></Nav>
    <div v-if="showoverlay" style="z-index: 999; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
      <b-spinner style="width: 3rem; height: 3rem;" label="Please wait..."></b-spinner>
    </div>
    <b-overlay class="overspin" :show="showoverlay" rounded="sm" fixed>

      <b-row class="py-3">
        <b-col>
          <h2>Performance Report</h2>
        </b-col>
      </b-row>

      <b-row class="py-2">
        <b-col cols="1">Year</b-col>
        <b-col cols="6"><b-form-spinbutton min="2020" max="2030" step="1" v-model="year" inline></b-form-spinbutton></b-col>
        <b-col cols="1"><b-button variant="light" @click="clearFilters">Clear</b-button></b-col>
        <b-col cols="2"><b-button variant="dark" @click="runPerformanceReport()">Run Report</b-button></b-col>
      </b-row>

      <b-table
       :items="results"
       :fields="fields"
      >
        <template #cell(sales_total_1)="data">
          {{ data.item.sales_total_1 | toCurrency }}
        </template>
        <template #cell(sales_total_2)="data">
          {{ data.item.sales_total_2 | toCurrency }}
        </template>
        <template #cell(sales_total_3)="data">
          {{ data.item.sales_total_3 | toCurrency }}
        </template>
        <template #cell(sales_total_4)="data">
          {{ data.item.sales_total_4 | toCurrency }}
        </template>
        <template #cell(sales_total_5)="data">
          {{ data.item.sales_total_5 | toCurrency }}
        </template>
        <template #cell(sales_total_6)="data">
          {{ data.item.sales_total_6 | toCurrency }}
        </template>
        <template #cell(sales_total_7)="data">
          {{ data.item.sales_total_7 | toCurrency }}
        </template>
        <template #cell(sales_total_8)="data">
          {{ data.item.sales_total_8 | toCurrency }}
        </template>
        <template #cell(sales_total_9)="data">
          {{ data.item.sales_total_9 | toCurrency }}
        </template>
        <template #cell(sales_total_10)="data">
          {{ data.item.sales_total_10 | toCurrency }}
        </template>
        <template #cell(sales_total_11)="data">
          {{ data.item.sales_total_11 | toCurrency }}
        </template>
        <template #cell(sales_total_12)="data">
          {{ data.item.sales_total_12 | toCurrency }}
        </template>

        <template v-slot:custom-foot>
          <b-tr class="table-footer">
            <b-td>TOTALS</b-td>
            <b-td>{{ makeSum('order_count_1') }}</b-td>
            <b-td>{{ makeSum('sales_total_1') | toCurrency }}</b-td>
            <b-td>{{ makeSum('order_count_2') }}</b-td>
            <b-td>{{ makeSum('sales_total_2') | toCurrency }}</b-td>
            <b-td>{{ makeSum('order_count_3') }}</b-td>
            <b-td>{{ makeSum('sales_total_3') | toCurrency }}</b-td>
            <b-td>{{ makeSum('order_count_4') }}</b-td>
            <b-td>{{ makeSum('sales_total_4') | toCurrency }}</b-td>
            <b-td>{{ makeSum('order_count_5') }}</b-td>
            <b-td>{{ makeSum('sales_total_5') | toCurrency }}</b-td>
            <b-td>{{ makeSum('order_count_6') }}</b-td>
            <b-td>{{ makeSum('sales_total_6') | toCurrency }}</b-td>
            <b-td>{{ makeSum('order_count_7') }}</b-td>
            <b-td>{{ makeSum('sales_total_7') | toCurrency }}</b-td>
            <b-td>{{ makeSum('order_count_8') }}</b-td>
            <b-td>{{ makeSum('sales_total_8') | toCurrency }}</b-td>
            <b-td>{{ makeSum('order_count_9') }}</b-td>
            <b-td>{{ makeSum('sales_total_9') | toCurrency }}</b-td>
            <b-td>{{ makeSum('order_count_10') }}</b-td>
            <b-td>{{ makeSum('sales_total_10') | toCurrency }}</b-td>
            <b-td>{{ makeSum('order_count_11') }}</b-td>
            <b-td>{{ makeSum('sales_total_11') | toCurrency }}</b-td>
            <b-td>{{ makeSum('order_count_12') }}</b-td>
            <b-td>{{ makeSum('sales_total_12') | toCurrency }}</b-td>
          </b-tr>
        </template>

      </b-table>
      <b-pagination v-model="currentPage" :total-rows="total_vendors" :per-page="limit" align="center" @change="changePage()"></b-pagination>
    </b-overlay>
  </b-container>
</template>


<script>
import Nav from '@/components/Nav.vue'
export default {
  name: "Performance",
  components: {
    Nav
  },
  data() {
    return {
      results: [],
      limit: 50,
      currentPage: 1,
      showoverlay: false,
      year: 2021,
      total_vendors: 0,
      fields: [
          'vendor_name',
          {key:'order_count_1', label:'Jan Orders'},
          {key:'sales_total_1', label:'Jan Sales'},
          {key:'order_count_2', label:'Feb Orders'},
          {key:'sales_total_2', label:'Feb Sales'},
          {key:'order_count_3', label:'Mar Orders'},
          {key:'sales_total_3', label:'Mar Sales'},
          {key:'order_count_4', label:'Apr Orders'},
          {key:'sales_total_4', label:'Apr Sales'},
          {key:'order_count_5', label:'May Orders'},
          {key:'sales_total_5', label:'May Sales'},
          {key:'order_count_6', label:'Jun Orders'},
          {key:'sales_total_6', label:'Jun Sales'},
          {key:'order_count_7', label:'Jul Orders'},
          {key:'sales_total_7', label:'Jul Sales'},
          {key:'order_count_8', label:'Aug Orders'},
          {key:'sales_total_8', label:'Aug Sales'},
          {key:'order_count_9', label:'Sept Orders'},
          {key:'sales_total_9', label:'Sept Sales'},
          {key:'order_count_10', label:'Oct Orders'},
          {key:'sales_total_10', label:'Oct Sales'},
          {key:'order_count_11', label:'Nov Orders'},
          {key:'sales_total_11', label:'Nov Sales'},
          {key:'order_count_12', label:'Dec Orders'},
          {key:'sales_total_12', label:'Dec Sales'},
      ],
    };
  },

  computed: {
    yearfilter: function() {
      if (this.year) {
        return '?year='+this.year;
      } else {
        return '';
      }
    },
  },

  methods: {
    makeSum(key) {
      var tot = this.results.reduce(function (total, currentValue) {
        if (currentValue[key] == undefined) {
          return total;
        } else {
          return total + currentValue[key];
        }
      }, 0);
      return tot;
    },

    async runPerformanceReport() {
      this.showoverlay = true;
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      const { data } = await this.$api.get("reports/vendor-performance"+this.yearfilter, {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      this.results = await data.performance;
      this.total_vendors = this.results.length;
      this.showoverlay = false;
    },

    changePage() {
      this.showoverlay = true;
      this.runPerformanceReport();
    },

    clearFilters() {
      this.year = '';
    },
  },

};
</script>
<style>
  .overspin .spinner-border {
    visibility: hidden;
  }

</style>
